import Button, {ButtonShape, ButtonVariant} from "@components/Button";
import Icon from "@components/Icon";
import React, {PropsWithChildren} from "react";

/**
 * This "Frame" component should be used as the top-level container in most (if not all) Popups.
 * It controls the whitespace & "X" button that appears in the top right corner.
 */
type FrameProps = {
  onClose: () => void;
  title?: JSX.Element;
};
const Frame = ({children, onClose, title}: PropsWithChildren<FrameProps>) => {
  return (
    <div className="flex flex-col gap-2 sm:gap-6 py-6 px-6">
      <div className={`flex flex-row ${title ? "justify-between" : "justify-end"}`}>
        {title}
        <CloseButton onClose={onClose} />
      </div>
      {children}
    </div>
  );
};

const CloseButton = ({onClose}: FrameProps) => (
  <Button
    ariaLabel="close"
    onClick={onClose}
    shape={ButtonShape.CIRCLE}
    variant={ButtonVariant.GHOST}
  >
    <div className="m-0.5 w-9 h-9">
      <Icon icon="close1" className="leading-9 text-gray-1000 text-base" />
    </div>
  </Button>
);

export default Frame;
